import * as GC from '@grapecity/spread-sheets';
import { isNumber } from '@helpers/arrays';
import { BehaviorSubject } from 'rxjs';

export class EquationBar {
  private spread: GC.Spread.Sheets.Workbook;
  public content$ = new BehaviorSubject(null);

  constructor(public content: string = null, public activeCell: { row: number; col: number } = { row: null, col: null }) {}

  public setSpread(spread: GC.Spread.Sheets.Workbook) {
    this.spread = spread;
  }
  public focusSpread() {
    this.spread.focus();
  }

  public isCellSelected() {
    const { row, col } = this.activeCell;
    return isNumber(row) && isNumber(col);
  }

  public contentChanged(event) {
    this.content = event;
    this.content$.next(event);
  }

  public onCellSelected(sheet: GC.Spread.Sheets.Worksheet, row: number, col: number, newText: string = null) {
    const activeCell = sheet.getCell(row, col);

    if (activeCell) {
      this.content = newText !== null ? newText : activeCell.value();
      this.activeCell = { row: activeCell.row, col: activeCell.col };
    } else {
      this.content = null;
      this.activeCell = { row: null, col: null };
    }
  }
}
